import { useState, useEffect } from 'react'

// Fetches live FX rates once (from our cached backend proxy of rter.info).
// Returns empty rates on failure so the converter can hide itself gracefully
// without ever breaking the payment form.
const useExchangeRates = (authState) => {
  const [rates, setRates] = useState(null)
  const [asOf, setAsOf] = useState(null)
  const [source, setSource] = useState(null)
  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState(null)

  useEffect(() => {
    let active = true
    if (authState && authState.api) {
      authState.api.getExchangeRates()
        .then((response) => {
          if (!active) { return }
          setRates(response.data.rates || null)
          setAsOf(response.data.as_of || null)
          setSource(response.data.source || null)
          setLoading(false)
        })
        .catch((error) => {
          if (!active) { return }
          setErr(error)
          setLoading(false)
        })
    }
    return () => { active = false }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [authState])

  return { rates, asOf, source, loading, err }
}

export default useExchangeRates
